module.exports = __webpack_public_path__ + "86f5b396b509d14b8d39a75886a8be3b.svg";